import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { EventPicturesReport } from './EventPicturesReport';

interface EventPicturesReportsRouteParams {
  id: string;
}

const EventPicturesReportsRoute: React.FC = () => {
  const { length, goBack } = useHistory();
  const params = useParams<EventPicturesReportsRouteParams>();

  const { id } = params;
  return (
    <EventPicturesReport
      standaloneMode={length <= 1}
      onClose={goBack}
      eventId={id}
    />
  );
};

export default EventPicturesReportsRoute;
